<template>
  <router-view/>
</template>

<script>

</script>


<style lang="scss">
body {
  margin: 0;
  padding: 0;
  background-color: $alt-color;
}

</style>
